var render = function render(){var _vm=this,_c=_vm._self._c;return _c('AgentPermissions',{attrs:{"permissions":_vm.transformedPermissions,"title":_vm.title},on:{"change":_vm.changePermission,"selectAll":function($event){return _vm.changeAll(true)},"deselectAll":function($event){return _vm.changeAll(false)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }